var React = require('react');

function Component (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.9691 15.7402C26.5397 10.2934 33.137 6.92211 40.2905 4.02664L51.1588 1.61147C63.5912 -1.23023 74.1267 1.85299 86.6015 1.85299C102.25 1.85299 123.369 2.96861 135.086 15.1365C148.565 29.1333 152.115 54.4479 138.105 69.2364C130.268 77.5089 120.999 81.4988 110.451 84.5124C107.308 85.4106 101.578 91.4799 99.142 94.0611L98.9793 94.2335C94.1377 99.3599 89.9998 105.504 84.3071 109.932C75.4624 116.811 66.1394 120.317 54.9627 120.317C38.3367 120.317 19.9568 113.915 9.85926 100.211C-2.52128 83.4089 -1.07437 63.1472 5.75346 44.2393C9.58546 33.6276 12.6989 23.8267 20.9691 15.7402Z","fill":"currentColor"}));
}

Component.defaultProps = {"width":"148","height":"121","viewBox":"0 0 148 121","fill":"none"};

module.exports = Component;

Component.default = Component;
